import React from "react";

function WhyChooseUs({ Features }) {
  return (
    <div>
      <section className="why-choose-us">
        <h2>we provide all the necessary material you need for your study</h2>
        <p>
          <span>
            Some interesting features and experiences provided by CBAstudyapp.
          </span>
        </p>
        <div className="grid-2">
          {Features.map((feature) => (
            <div key={feature.id}>
              <figure>
                <div className="icon-container">
                  <span className="icon">{feature.icon}</span>
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.text}</p>
              </figure>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default WhyChooseUs;
